/* eslint-disable no-secrets/no-secrets */
/* eslint-disable camelcase */
/* eslint-disable max-len */
import React, { useCallback, useState, useEffect, useRef } from 'react';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import PropTypes from 'prop-types';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import {CustomQuoteService as GatewayCustomQuoteService, LoadSaveService} from 'gw-capability-gateway-quoteandbind';
import { useTranslator } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { MLLocalDateUtil,MLProductCodeUtil } from 'ml-portals-util-js';
import { MLNotificationBlockUtil } from 'ml-portals-util-react';
import { MLModalService } from 'ml-portals-services-react';
import { platformMessages } from 'ml-components-platform-react';
import { MLBundleService } from 'ml-services-common-react';
import { ClausesUtil } from '@xengage/gw-policycommon-util-js';
import {
    MLPAEditCoveragesComponent,
    MLHOEditCoveragesComponent,
    MLPUPEditCoveragesComponent,
    MLPAAgentEditCoveragesComponent
} from 'ml-components-common-react';
import { MVR_ERR1,MVR_ERR2,MVR_ERR3 } from '../../../../override/constants/ml-mvr-constants';
import QuotePageUmbExposuresComponent from '../../../gw-capability-quoteandbind-pup-react/components/QuotePageUmbExposuresComponent/QuotePageUmbExposuresComponent';
import metadata from './CustomQuoteComponent.metadata.json5';
import messages from './CustomQuoteComponent.messages';
import { UserService } from 'gw-capability-gateway';
import PUMBTrackEvent from '../../../gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PUMBTrackEvent';
import HOTrackEvent from '../../../gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/HOTrackEvent';
import PATrackEvent from '../../../gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PATrackEvent';

const excludedCoveragesWithDependencies = [
    'HOPPrivateStructureExclusion_ML',
    'HOPOffPremisesTheftExclusion',
    'HOPWindstormOrHailCoverageExclusion',
    'HOPMasonryVeneerExclusion_ML',
    'GenericHOPEarthquakeMasonryExclType'
];

function CustomQuoteComponent(props) {
    const {
        submissionVM,
        customQuote,
        isAgent,
        isDisplayOnly,
        addVehicle,
        editVehicle,
        removeVehicle,
        editCoverage,
        hideEditLinks,
        hideEditCoverage,
        updateWizardData,
        lobPath,
        isBundle,
        refreshSelectedQuoteObj,
        navigateToStep,
        prevIndex,
        nextIndex,
        isPrevAvailable,
        isNextAvailable,
        lineCoverageNamesMap,
        vehicleCoverageNamesMap,
        optionalCoverageNamesMap,
        coverablesToDisplay,
        updateMaps,
        onPrevButtonClick,
        onNextButtonClick,
        termMonths,
        onAgentUpdatedCustomQuote,
        setIsPUPPolicyRefreshed_Ext,
        setUnderlyingPolicies,
        viewModelService,
        currentUser
    } = props;

    const {
        clearBlockAlerts,
        addErrorAlert,
        addWarningAlert,
        clearManyBlockAlertsStartsWith
    } = MLNotificationBlockUtil();

    const {
        showProgressDialog,
        hideProgressDialog,
        showErrorModal
    } = MLModalService();

    const translator = useTranslator();
    const { authHeader } = useAuthentication();
    const { CustomQuoteService } = useDependencies('CustomQuoteService');
    const quoteID = _.get(submissionVM, 'quoteID.value');
    const sessionUUID = _.get(submissionVM, 'sessionUUID.value');
    const productCode = _.get(submissionVM, 'baseData.productCode.value');
    const selectedTermType = _.get(submissionVM, 'baseData.termType_ML.value.code', '');
    const hoCoveragePartType = _.get(submissionVM, 'lobData.homeowners.coverables.coveragePartType_ML.value');
    const isAlaska7Day = _.get(submissionVM, 'baseData.policyAddress.state.value') === 'AK' && _.get(submissionVM, 'baseData.termType.value') === '7Days';

    const totalFees = _.get(customQuote, 'totalChanges_Ext', {});
    const itemizedFees = _.get(customQuote, 'feesCosts_Ext', []);

    const isHomeowners = MLProductCodeUtil.isHomeOwners(productCode);
    const { MLUserTypes } = appConfig;
   
    const coveragePartType = submissionVM?.lobData?.homeowners?.coverables?.coveragePartType_ML?.value?.code;

    const isModernProduct = _.get(submissionVM, 'isModernProduct_Ext.value', false);
    const updateInProgressRef = useRef(false)

    const isNotDwellingPolicy = !(MLProductCodeUtil.isHomeOwnersPartialTypeHome(coveragePartType))

    const isLLPolicy = MLProductCodeUtil.isHomeOwnersPartialTypeLandlordCondo(coveragePartType) || MLProductCodeUtil.isHomeOwnersPartialTypeLandlordHome(coveragePartType) 

    const isEligibleModernHomeowners = isModernProduct &&
        MLProductCodeUtil.isHomeOwners(submissionVM.baseData.productCode.value) &&
        (
            MLProductCodeUtil.isHomeOwnersPartialTypeHome(coveragePartType) ||
            MLProductCodeUtil.isHomeOwnersPartialTypeCondo(coveragePartType)
        );

    const occupancyType = submissionVM?.lobData?.homeowners?.preQualQuestionSets?.value?.[0]?.answers?.HOPPreQualHomeCondoDwellingOccupancy_Ext
    const isOccupancySecondaryOrSeasonal = isEligibleModernHomeowners && ['HOPPreQualHomeCondoOccupancySecondary', 'HOPPreQualHomeCondoOccupancySeasonal'].includes(occupancyType);

    const getCurrentOfferingCoverages = useCallback(() => {
        const offerings = _.get(submissionVM, `lobData.${lobPath}.offerings.value`, []);
        const selectedOffering = offerings.find((o) => o.branchCode === customQuote.branchCode && o.branchPublicID === customQuote.publicID);
        return _.get(selectedOffering, 'coverages');
    }, [customQuote.branchCode, customQuote.branchName, lobPath, submissionVM]);
    const [covsModel, setCovsModel] = useState(getCurrentOfferingCoverages());

    const parseErrorForMessage = (errorString) => {
        const indexOfMessages = errorString.indexOf('Messages_ML');
        let errorMessages = errorString.substring(indexOfMessages).split(']')[0];
        errorMessages = errorMessages.split('[')[1];
        return errorMessages.split(',')[0];
    };

    const goToContactUs = () => {
        const contactUsPath = 'quote-and-buy/contact-us';
        const url = `${window.location.origin}/${contactUsPath}`;
        window.location.href = url;
    };

    const handleQuoteError = useCallback((error) => {
        console.error('Error updating custom quote', error);

        const code = _.get(error, 'appErrorCode');

        if (isAgent && code === -31000 && ['806', '807'].includes(error.errorCode)) {
            addErrorAlert(parseErrorForMessage(error.baseError), 'updateQuoteError');
        }  else if (code === 101 && ['GW_BLOCK_QUOTE_UNDERWRITING_ERROR'].includes(error.errorCode)) {
            showErrorModal(messages.policyTermUnavailableHeaderMessage, messages.policyTermUnavailable);
        } else if (error.data?.appError === "GW_AUTHENTICATION_ERROR") {
            showErrorModal(messages.genericErrorMessage, messages.genericErrorMessage);
        } else if (isAgent) {
            showErrorModal(messages.modalErrorMessage, messages.modalErrorDesc);
        } else {
            goToContactUs();
        }
    }, [addErrorAlert, isAgent, showErrorModal]);

    const createCustomQuoteRequest = useCallback((sub) => {
        const coverages = {
            [`${lobPath}`]: getCurrentOfferingCoverages()
        };
  
        if(isHomeowners) {
            coverages?.homeowners?.baseCoverages?.forEach((baseCov) => {
                if(baseCov.code_ML === 'HOPCovA'){
                    baseCov.terms?.forEach((term) => {
                        if(term.codeIdentifier_ML === 'HOPCovALimit' && term.directValue) {
                            term.directValue = String(term.directValue).replace(/,/g,'');
                        }
                    });

                } 

                if(baseCov.code_ML === 'HOPCovB'){
                    baseCov.terms?.forEach((term) => {
                        if(term.codeIdentifier_ML === 'HOPCovBDirectLimit' && term.directValue) {
                            term.directValue = String(term.directValue).replace(/,/g,'');
                        }
                    });

                } 
                
                if(baseCov.code_ML === 'HOPCovC'){
                    baseCov.terms?.forEach((term) => {
                        if(term.codeIdentifier_ML === 'HOPCovCDirectLimit' && term.directValue) {
                           term.directValue = String(term.directValue).replace(/,/g,'');
                        }
                    });
                }

                if(baseCov.code_ML === 'HOPLineWorkersCompensation_ML'){
                    baseCov.terms?.forEach((term) => {
                        if(term.codeIdentifier_ML === 'HOPLineWorkersCompInServantNum_Ext' && term.directValue){
                           term.directValue = String(term.directValue).replace(/,/g,''); 
                        }
                        if(term.codeIdentifier_ML === 'HOPLineWorkersCompOutServantNum_Ext' && term.directValue){
                           term.directValue = String(term.directValue).replace(/,/g,''); 
                        }
                        if(term.codeIdentifier_ML === 'HOPLineWorkersCompOccServantNum_Ext' && term.directValue){
                           term.directValue = String(term.directValue).replace(/,/g,''); 
                        }
                    });

                }
            });
        };

        return {
            quote: customQuote,
            quoteID: customQuote.quoteID,
            sessionUUID: sessionUUID,
            ratingPaymentMethod_ML: customQuote.ratingPaymentMethod_ML,
            ratingPaymentSchedule_ML: customQuote.ratingPaymentSchedule_ML,
            markAsSelectedVersion_ML: true,
            productCode_ML: _.get(sub, 'baseData.productCode'),
            producerCodeOfRecord_ML: _.get(sub, 'bindData.producerCodeOfRecord_ML'),
            coverages,
            refferalAgentProducerCode : (currentUser?.userType === MLUserTypes.GCS_SALES && isModernProduct) ? currentUser?.primaryProducerCode_ML?.code : null
        };
    }, [getCurrentOfferingCoverages, customQuote, lobPath, sessionUUID]);

    /**
     * Checks that there are no invalid inputs or nested forms, displays a modal prompting the user to
     * fix errors.
     *
     * @returns {boolean}
     */
    const customValidateInputFields = useCallback(() => {
        const additionalInterests = submissionVM?.lobData?.homeowners?.coverables?.additionalInterests?.value;
        additionalInterests?.forEach((item) => {
            const contact = item?.policyAdditionalInterest;
            if (contact && contact?.policyBillingDocCommPref_Ext === 'email') {
                contact.policyBillingDocCommPref_Ext = undefined;
            }
        });

        if (!submissionVM.aspects.subtreeValid) {
            showErrorModal(messages.modalInputErrorMessage, messages.modalInputErrorDesc)
            return false;
        }
        return true;
    }, [showErrorModal, submissionVM]);

    const checkCoveragesMismatch = useCallback(() => {
        _.set(customQuote, 'quoteStatus.coverageMismatch', false);
        _.set(customQuote, 'quoteStatus.coverageMismatchAlerts', []);
        clearBlockAlerts('customQuoteCoverageMismatch');
        const currentOfferingCoverages = getCurrentOfferingCoverages()
        let allCovs = _.get(currentOfferingCoverages, 'lineCoverages', []).concat(_.get(currentOfferingCoverages, 'optionalCoverages_ML', []));
        coverablesToDisplay.forEach((coverable) => {
            allCovs = allCovs.concat(coverable.syncedCoverages);
        });
        setTimeout(() => {
            allCovs.forEach((coverage) => {
                // PUPAnimalLiabilityExclusion_ML terms will be eliminated in MLPUPEditCoveragesComponent so we'll skip the error messages.
                if (coverage.code_ML === 'PUPAnimalLiabilityExclusion_ML') {
                    return;
                }
                coverage.terms.forEach((term) => {
                    if (term.validationMessage_ML) {
                        _.set(customQuote, 'quoteStatus.coverageMismatch', true);
                        addErrorAlert(term.validationMessage_ML, 'customQuoteCoverageMismatch')
                    }
                });
            });
        }, 100);
    }, [addErrorAlert, clearBlockAlerts, coverablesToDisplay, getCurrentOfferingCoverages, customQuote]);

    const clearValidationAlerts = useCallback(() => {
        clearManyBlockAlertsStartsWith('validation-');
        customQuote.validationErrors_ML = undefined;
    }, [clearManyBlockAlertsStartsWith, customQuote]);

    const clearPerilAlerts = useCallback(() => {
        clearBlockAlerts('windHail');
        clearBlockAlerts('roofLoss');
        clearBlockAlerts('allOtherPeril');
        clearBlockAlerts('grcAvailable');
    }, [clearBlockAlerts]);


    const structureVehicleCoveragesForServer = (structuredClauses) => {
        structuredClauses?.personalAuto.vehicleCoverages.forEach((vehicle) => {
            vehicle.coverages = vehicle.coverages.filter((cov) => {
                return (cov.updated || cov.terms.some((term) => {
                    return term.updated
                }))
            })
        });
    };
    
    const hasDependentCoverages = (covCode) => {
        const dependencyList = ClausesUtil.getDependentClauseList();
        
        if (excludedCoveragesWithDependencies.includes(covCode) || !covCode) {
            return true;
        }

        return dependencyList && dependencyList.some((elt) => {
            return elt.name === covCode;
        })
    };

    const syncCoverage = useCallback(async (callback, covCode, hasTerms, shouldRefresh = false) => {
        if (isAgent) {
            clearValidationAlerts();
        }
        let lobCoverages = {};

        _.set(customQuote, 'quoteStatus.isStale', true);

        const coverages = {
            [`${lobPath}`]: covsModel
        };

        lobCoverages = _.get(coverages, `${lobPath}`, {});

        if (lobPath === 'personalAuto' ) {
            const currentOfferings = getCurrentOfferingCoverages();
            
            _.set(lobCoverages, 'vehicleCoverages', currentOfferings.vehicleCoverages);
        }

        setCovsModel(lobCoverages);
        const shouldUpdate = shouldRefresh; // ClausesUtil.isDependentClausesEmpty() || hasTerms || hasDependentCoverages(covCode);

        if (isModernProduct && isHomeowners) {
            if (updateInProgressRef.current) {
                return;
            }

            updateInProgressRef.current = true;
        }
        try {
            if (shouldUpdate) {
                const structuredClauses = ClausesUtil.structureClausesForServer(
                    covsModel,
                    lobPath,
                    null
                );

                if (lobPath === 'personalAuto' ) {
                    structureVehicleCoveragesForServer(structuredClauses)
                }

                _.set(customQuote, 'quoteStatus.showLoading', true);
                _.set(customQuote, 'quoteStatus.calculatingQuote', true);

                const customQuoteDTO = {
                    quote: customQuote,
                    sessionUUID,
                    quoteID,
                    productCode_ML: productCode,
                    markAsSelectedVersion_ML: customQuote.isSelected,
                    isSubmitAgent: false,
                    coverages: (!covCode || ClausesUtil.isDependentClausesEmpty()) ? coverages : structuredClauses
                };

                const updatePromise = isAgent ?
                    GatewayCustomQuoteService.updateCustomQuoteCoverages(customQuoteDTO, authHeader) :
                    CustomQuoteService.updateCustomQuoteCoverages(customQuoteDTO);

                showProgressDialog(platformMessages.updatingQuote, updatePromise, true, 30000);

                const quote = await updatePromise;

                customQuote.script_ML = quote.script_ML;
                customQuote.uwIssues_ML = quote?.errorsAndWarnings?.underwritingIssues;
                customQuote.hasError = false;

                const offerings = _.get(submissionVM, `lobData.${lobPath}.offerings.value`, []);
                const selectedOfferingIndex = offerings.findIndex((o) => o.branchCode === customQuote.branchCode && o.branchPublicID === customQuote.publicID);
                _.set(submissionVM, `lobData.${lobPath}.value.offerings[${selectedOfferingIndex}].coverages`, _.get(quote, `coverages.${lobPath}`));

                lobCoverages = _.get(quote, `coverages.${lobPath}`, {});
                setCovsModel(lobCoverages);

                _.set(customQuote, 'status', _.get(quote, 'quote.status'));

            } else {
                const offerings = _.get(submissionVM, `lobData.${lobPath}.offerings.value`, []);
                const selectedOfferingIndex = offerings.findIndex((o) => o.branchCode === customQuote.branchCode && o.branchPublicID === customQuote.publicID);
                _.set(submissionVM, `lobData.${lobPath}.value.offerings[${selectedOfferingIndex}].coverages`, lobCoverages);
            }
        }
        catch (error) {
            handleQuoteError(error);
        }
        finally {
            updateInProgressRef.current = false;
            if (covCode === 'PAAgreedValueCov_ML' || covCode === 'PAAgreedValueCollectibleCov_ML') {
                // if Agreed Value updated we must retrieve the full submission from PC so that we can update WizardData with the new vehicle values
                const requestData = {
                    quoteID: submissionVM.quoteID.value,
                    postalCode: submissionVM.baseData?.policyAddress?.postalCode?.value?.substring(0, 5)
                };
                const submissionLoadPromise = LoadSaveService.retrieveSubmission(requestData, authHeader);
                
                try {
                    const sub = await submissionLoadPromise;
                    const subVM = viewModelService.create(sub, 'pc', 'edge.capabilities.quote.submission.dto.QuoteDataDTO');
                    
                    _.set(submissionVM, 'value.lobData.personalAuto.coverables.vehicles', _.get(subVM, 'value.lobData.personalAuto.coverables.vehicles'));
                } catch (error) {

                    if (
                      error.baseError &&
                      (error.baseError.includes(
                        MVR_ERR1,
                      ) ||
                        error.baseError.includes(
                          MVR_ERR2,
                        ) ||
                        error.baseError.includes(
                          MVR_ERR3,
                        ))
                    ) {
                      addErrorAlert(
                        messages.mvrErrorMessage.defaultMessage,
                        "mvrError",
                      );
                    } else {
                      // eslint-disable-next-line no-console
                      console.error(error);
                    }
                }
            }

            _.set(customQuote, 'quoteStatus.isStale', true);
            _.set(customQuote, 'quoteStatus.showLoading', false);
            _.set(customQuote, 'quoteStatus.calculatingQuote', false);

            const offeredQuotes = _.get(submissionVM, 'quoteData.offeredQuotes.value', []);
            const indexOfCustomQuote = offeredQuotes.findIndex((offQuote) => offQuote.publicID === customQuote.publicID);
            _.set(submissionVM, `quoteData.offeredQuotes.value[${indexOfCustomQuote}]`, customQuote);

            refreshSelectedQuoteObj(customQuote);
            updateWizardData(submissionVM);
            if (!_.isUndefined(callback)) {
                callback();
            }

            _.set(customQuote, 'quoteStatus.coverageMismatch', false);
            _.set(customQuote, 'quoteStatus.coverageMismatchAlerts', []);
            clearBlockAlerts('customQuoteCoverageMismatch');
        }
    }, [isAgent, customQuote, lobPath, covsModel, sessionUUID, quoteID, productCode, clearValidationAlerts, authHeader, CustomQuoteService, showProgressDialog, submissionVM, handleQuoteError, refreshSelectedQuoteObj, updateWizardData, checkCoveragesMismatch, getCurrentOfferingCoverages]);

    const quotePayments = useCallback(() => {
        if (isAgent) {
            return;
        }
        const { MLRatingForMonthlyPayment, MLRatingForAnnualPayment, MLRatingForMortgageePayment } = appConfig.mlRatingConfigs;
        const paymentPlanIDs = [MLRatingForMonthlyPayment, MLRatingForAnnualPayment];
        if (!_.isUndefined(hoCoveragePartType) && hoCoveragePartType.code !== 'hoprental') {
            paymentPlanIDs.push(MLRatingForMortgageePayment);
        }

        const createdQuotes = [];
        const quotePromise = isAgent ?
            GatewayCustomQuoteService.requestQuotesForSpecifPaymentPlans(sessionUUID, quoteID, customQuote.publicID, paymentPlanIDs, authHeader) : CustomQuoteService.requestQuotesForSpecifPaymentPlans(sessionUUID, quoteID, customQuote.publicID, paymentPlanIDs);
        showProgressDialog(platformMessages.updatingQuote, quotePromise);
        quotePromise.then((quotes) => {
            createdQuotes.push(...quotes);
            customQuote.others = createdQuotes;
        }, (error) => {
            // eslint-disable-next-line no-console
            console.error(error);
            _.set(customQuote, 'quoteStatus.isStale', true);
            customQuote.hasError = true;
            customQuote.others = [];
        }).finally(() => {
            customQuote.showLoading = false;
            refreshSelectedQuoteObj(customQuote);
            // $scope.$emit('$customQuotePaymentPlansComplete');
        });
        return quotePromise;
    }, [CustomQuoteService, authHeader, customQuote, hoCoveragePartType, isAgent, quoteID, refreshSelectedQuoteObj, sessionUUID, showProgressDialog]);

    const setValidationErrorAlerts = useCallback((errors) => {
        if (!_.isEmpty(errors)) {
            _.uniq(errors).forEach((error, index) => {
                const alertName = `validation-${index}`;
                addErrorAlert(error, alertName);
            });
        }
    }, [addErrorAlert]);

    const setPerilAlerts = useCallback((warnings) => {
        if (!_.isEmpty(warnings)) {
            if (warnings.includes("WindHail")) {
                addWarningAlert(messages.windstormHailDeductibleBumpedWarning, "windHail");
            }

            if (warnings.includes("MinRoofAge")) {
                addWarningAlert(messages.roofLossSettlementBumpedWarning, "roofLoss");
            }

            if (warnings.includes("AllOtherPeril")) {
                addWarningAlert(messages.allOtherPerilBumpedWarning, "allOtherPeril");
            }

            if (warnings.includes("GRCAvailable")) {
                addWarningAlert(messages.grcAvailableBumpedWarning, "grcAvailable");
            }
        }
    }, [addWarningAlert]);

    const refreshBundleWidget = () => {
        MLBundleService.refreshBundleSummary(submissionVM.value.baseData.accountNumber, authHeader)
            .then(() => {
                setTimeout(() => {
                    window.dispatchEvent(new Event('MLBundleWidget_updateJobs'));
                }, 100);
            })
            .catch((error) => {console.error(error);});
    };

    const updateCustomQuote = useCallback(async (sub) => {
        if (!_.get(customQuote, 'quoteStatus.isStale', false) || !customValidateInputFields()) {
            // disable action if coverage selections have not changed or we don't have an existing quote price
            return;
        }
        showProgressDialog(platformMessages.updatingQuote);
        let updatedLobCoverages = {};
        customQuote.others = undefined;
        _.set(customQuote, 'quoteStatus.isStale', true);
        _.set(customQuote, 'quoteStatus.showLoading', true);
        _.set(customQuote, 'quoteStatus.calculatingQuote', true);
        _.set(customQuote, 'quoteStatus.effectiveDateChange', true);
        refreshSelectedQuoteObj(customQuote);
        if (isAgent) {
            clearValidationAlerts();
        }

        clearPerilAlerts();

        const updateCustomQuoteRequest = createCustomQuoteRequest(sub.value);

        try {
            const updatedCustomQuote = isAgent ?
                await GatewayCustomQuoteService.updateCustomQuote(updateCustomQuoteRequest, authHeader) : await CustomQuoteService.updateCustomQuote(updateCustomQuoteRequest);

            if (isAgent) {
                customQuote.retrievedOnly = false;
                const updatedPaymentPlanCustomQuote = onAgentUpdatedCustomQuote(customQuote, updatedCustomQuote.quote);
                customQuote.availablePaymentPlans = updatedPaymentPlanCustomQuote.availablePaymentPlans;
                customQuote.selectedPaymentPlan = updatedPaymentPlanCustomQuote.selectedPaymentPlan;
            }
            updatedLobCoverages = _.get(updatedCustomQuote, `coverages.${lobPath}`, {});
            const updatedQuote = _.get(updatedCustomQuote, 'quote', {});

            const bumpedPerils = _.get(updatedCustomQuote, 'perilBumpedCoverages_Ext', [])
            const isPUPPolicyRefreshed_Ext = _.get(updatedCustomQuote, "isPUPPolicyRefreshed_Ext", false);
            if (isAgent) {
                setIsPUPPolicyRefreshed_Ext(isPUPPolicyRefreshed_Ext);
                setUnderlyingPolicies(_.get(updatedCustomQuote, "underlyingPolicies", []));
            }

            setPerilAlerts(bumpedPerils);

            customQuote.coveragePackageLevel_Ext = updatedQuote.coveragePackageLevel_Ext;
            customQuote.termType_ML = updatedQuote.termType_ML;
            customQuote.premium.total = updatedQuote.premium.total;
            customQuote.premium.monthlyPremium = updatedQuote.premium.monthlyPremium;
            customQuote.totalChanges_Ext = updatedQuote.totalChanges_Ext;
            customQuote.feesCosts_Ext = updatedQuote.feesCosts_Ext;
            customQuote.totalFullTermChargesRPT_Ext = updatedQuote.totalFullTermChargesRPT_Ext;
            customQuote.fullTermFeesCosts_Ext = updatedQuote.fullTermFeesCosts_Ext;
            customQuote.uwIssues_ML = updatedQuote.uwIssues_ML;
            customQuote.discounts_ML = updatedQuote.discounts_ML;
            customQuote.indicativeUmbQuoteIndicator_Ext = updatedQuote.indicativeUmbQuoteIndicator_Ext;
            customQuote.premium.indicativeUmbPremium = updatedQuote.premium.indicativeUmbPremium;
            customQuote.hasUmbrellaOnAccount_Ext = updatedQuote.hasUmbrellaOnAccount_Ext;
            customQuote.status = updatedQuote.status;
            customQuote.isAnnualTermEligible = updatedQuote.isAnnualTermEligible

            customQuote.validationErrors_ML = updatedQuote.validationErrors_ML;
            if (customQuote.validationErrors_ML) {
                customQuote.hasError = true;
                _.set(customQuote, 'quoteStatus.isStale', true);
                _.set(customQuote, 'quoteStatus.showLoading', false);
                if (isAgent) {
                    setValidationErrorAlerts(customQuote.validationErrors_ML);
                }
                window.scrollTo(0, 0);
            } else {
                customQuote.hasError = false;

                _.set(customQuote, 'quoteStatus.isStale', false);

                await quotePayments(customQuote);

                _.set(submissionVM, 'baseData.periodStartDate.value', updatedCustomQuote.quote.periodStartDate);
                _.set(submissionVM, 'baseData.periodEndDate.value', updatedCustomQuote.quote.periodEndDate);
                if (!_.isUndefined (_.get(submissionVM, 'bindData.paymentDetails.preferredPaymentMethodInd_Ext'))) {
                    _.set(submissionVM, 'bindData.paymentDetails.preferredPaymentMethodInd_Ext.value', 
                        updatedCustomQuote.quote.preferredPaymentMethodInd_Ext
                    );
                }
                const offerings = _.get(submissionVM, `lobData.${lobPath}.offerings.value`, []);
                const selectedOfferingIndex = offerings.findIndex((o) => o.branchCode === customQuote.branchCode && o.branchPublicID === customQuote.publicID);
                _.set(submissionVM, `lobData.${lobPath}.value[${selectedOfferingIndex}].coverages`, updatedCustomQuote.coverages);
                _.set(submissionVM, `lobData.${lobPath}.value.offerings[${selectedOfferingIndex}].coverages`, _.get(updatedCustomQuote, `coverages.${lobPath}`));

                if (isAgent) {
                    UserService.getCurrentUser(authHeader).then((user) => {

                        if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                            PUMBTrackEvent('Quote Recalculated', true, submissionVM, user, {total_Premium: `$${customQuote.premium.total.amount}`, monthly_premium:`$${customQuote.premium.monthlyPremium.amount}`});
                        }
                        else if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                            HOTrackEvent('Quote Recalculated', true, submissionVM, user, {step: "Quote Page", total_Premium: `$${customQuote.premium.total.amount}`, monthly_premium:`$${customQuote.premium.monthlyPremium.amount}`});
                        }
                        else {
                            PATrackEvent('Quote Recalculated', true, submissionVM, user, {step: "Quote Page", total_Premium: `$${customQuote.premium.total.amount}`, monthly_premium:`$${customQuote.premium.monthlyPremium.amount}`});
                        }
                    });
                }
            }
        }
        catch (error) {
            customQuote.hasError = true;
            _.set(customQuote, 'quoteStatus.isStale', true);
            handleQuoteError(error);
        }
        finally {
            _.set(customQuote, 'quoteStatus.showLoading', false);
            _.set(customQuote, 'quoteStatus.calculatingQuote', false);
            _.set(customQuote, 'quoteStatus.effectiveDateChange', true);
            customQuote.showLoading = false;
            hideProgressDialog();

            const offeredQuotes = _.get(submissionVM, 'quoteData.offeredQuotes.value', []);
            const indexOfCustomQuote = offeredQuotes.findIndex((offQuote) => offQuote.publicID === customQuote.publicID);
            _.set(submissionVM, `quoteData.offeredQuotes.value[${indexOfCustomQuote}]`, customQuote);
           
            const offerings = _.get(submissionVM, `lobData.${lobPath}.offerings.value`, []);
            const selectedOfferingIndex = offerings.findIndex((o) => o.branchCode === customQuote.branchCode && o.branchPublicID === customQuote.publicID);

            if(selectedOfferingIndex !== -1 && offerings){
                _.set(submissionVM, `lobData.${lobPath}.offerings.children[${selectedOfferingIndex}].coverages.value`, updatedLobCoverages);
            }

            updateWizardData(submissionVM);
            refreshSelectedQuoteObj(customQuote);
            setCovsModel(updatedLobCoverages);
            if(!customQuote?.hasError) {
                refreshBundleWidget();
            }
        }
    }, [CustomQuoteService, authHeader, createCustomQuoteRequest, customQuote, customValidateInputFields, handleQuoteError, isAgent, lobPath, quotePayments, refreshSelectedQuoteObj, submissionVM, updateWizardData, clearValidationAlerts, clearPerilAlerts, setValidationErrorAlerts, setPerilAlerts, showProgressDialog, hideProgressDialog]);


    const markStale = useCallback(() => {

    }, []);

    const isQuoteStale = () => {
        return _.get(customQuote, 'quoteStatus.isStale', false);
    };

    useEffect(() => {
        customQuote.validateInputFields = customValidateInputFields;
        customQuote.updateQuote = updateCustomQuote;
        if (_.isUndefined(customQuote.quoteStatus)) {
            customQuote.quoteStatus = {
                calculatingQuote: false,
                showLoading: false,
                displayed: false,
                isStale: isAgent && customQuote.retrievedOnly === true,
                effectiveDateChanged: false
            };
        }
        // This code will be executed once the component unmount,
        // preventing this functions from living beyond this page.
        // If we don't do this, in case of a failure in the quote page
        // The system will try to clone the object and fail (cannot clone function)
        // This is also done in v9 as well.
        return () => {
            if (customQuote) {
                delete customQuote.validateInputFields;
                delete customQuote.updateQuote;
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customQuote]);

    const resolvers = {
        resolveComponentMap: {
            mlpupeditcoveragescomponent: MLPUPEditCoveragesComponent,
            mlpaeditcoveragescomponent: MLPAEditCoveragesComponent,
            mlhoeditcoveragescomponent: MLHOEditCoveragesComponent,
            quotepageumbexposurescomponent: QuotePageUmbExposuresComponent,
            mlpaagenteditcoveragescomponent: MLPAAgentEditCoveragesComponent
        }
    };

    const overrides = {
        paEditCoveragesQnbNonAgent: {
            visible: !_.isUndefined(_.get(submissionVM, 'lobData.personalAuto.value', undefined)) && !isAgent,
            model: covsModel,
            loading: _.get(customQuote, 'quoteStatus.showLoading', false),
            onCovChange: syncCoverage,
            onGeneralChange: markStale,
            isDisplayOnly: isDisplayOnly,
            addVehicle: addVehicle,
            editVehicle: editVehicle,
            removeVehicle: removeVehicle,
            editCoverage: editCoverage,
            hideEditLinks: hideEditLinks,
            hideCoverageButton: hideEditCoverage,
            selectedTermType: selectedTermType,
            submissionVM
        },
        paEditCoveragesAgent: {
            visible: !_.isUndefined(_.get(submissionVM, 'lobData.personalAuto.value', undefined)) && isAgent,
            coverages: covsModel,
            loading: _.get(customQuote, 'quoteStatus.showLoading', false),
            onCovChange: syncCoverage,
            onGeneralChange: markStale,
            isDisplayOnly: isDisplayOnly,
            isAlaska7Day,
            totalFees,
            itemizedFees,
            addVehicleButton: true,
            prevIndex,
            nextIndex,
            isPrevAvailable,
            isNextAvailable,
            lineCoverageNamesMap,
            vehicleCoverageNamesMap,
            optionalCoverageNamesMap,
            coverablesToDisplay,
            updateMaps,
            onPrevButtonClick,
            onNextButtonClick,
            termMonths,
            navigateToStep,
            isBundle,
            quoteStatus: _.get(customQuote, 'quoteStatus', {}),
            isModernProduct,
            submissionVM
        },
        hoEditCoveragesComponent: {
            visible: !_.isUndefined(_.get(submissionVM, 'lobData.homeowners.value')),
            loading: _.get(customQuote, 'quoteStatus.showLoading', false),
            model: covsModel,
            onCovChange: syncCoverage,
            onGeneralChange: markStale,
            isDisplayOnly: isDisplayOnly,
            editCoverage,
            isAgent,
            showEditCoverage: !isBundle && isDisplayOnly,
            isQuoteStale,
            totalFees,
            itemizedFees,
            isOccupancySecondaryOrSeasonal,
            isModernProduct,
            isNotDwellingPolicy,
            isLLPolicy,
            submissionVM
        },
        pupDiv: {
            visible: !_.isUndefined(_.get(submissionVM, 'lobData.personalUmbrella.value'))
        },
        pupEditCoveragesComponent: {
            model: covsModel,
            loading: _.get(customQuote, 'quoteStatus.showLoading', false),
            onCovChange: syncCoverage,
            onGeneralChange: markStale,
            isDisplayOnly: isDisplayOnly,
            editCoverage,
            showEditCoverage: !isBundle && isDisplayOnly,
            totalCoverage: _.get(customQuote, 'premium.totalBeforeTaxes'),
            isQuoteStale
        },
        pupExposuresComponent: {
            submissionVM,
            navigateToStep,
            updateWizardData,
            isGateway: isAgent,
            viewModelService
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

CustomQuoteComponent.propTypes = {
    submissionVM: PropTypes.shape({}),
    customQuote: PropTypes.shape({}),
    isAgent: PropTypes.bool,
    isDisplayOnly: PropTypes.bool,
    isAlaska7Day: PropTypes.bool,
    addVehicle: PropTypes.func,
    editVehicle: PropTypes.func,
    removeVehicle: PropTypes.func,
    editCoverage: PropTypes.func,
    hideEditLinks: PropTypes.bool,
    hideEditCoverage: PropTypes.bool,
    updateWizardData: PropTypes.func,
    lobPath: PropTypes.string,
    isBundle: PropTypes.bool,
    refreshSelectedQuoteObj: PropTypes.func,
    navigateToStep: PropTypes.func,
    prevIndex: PropTypes.number,
    nextIndex: PropTypes.number,
    isPrevAvailable: PropTypes.func,
    isNextAvailable: PropTypes.number,
    lineCoverageNamesMap: PropTypes.arrayOf(PropTypes.shape({})),
    vehicleCoverageNamesMap: PropTypes.arrayOf(PropTypes.shape({})),
    optionalCoverageNamesMap: PropTypes.arrayOf(PropTypes.shape({})),
    coverablesToDisplay: PropTypes.arrayOf(PropTypes.shape({})),
    updateMaps: PropTypes.func,
    onPrevButtonClick: PropTypes.func,
    onNextButtonClick: PropTypes.func,
    updatePupLiabilityWarning: PropTypes.func,
    termMonths: PropTypes.number,
    addBannerMessage: PropTypes.func.isRequired,
    currentUser: PropTypes.shape({})
};

CustomQuoteComponent.defaultProps = {
    refreshSelectedQuoteObj: _.noop,
};

export default CustomQuoteComponent;
